<h1 mat-dialog-title align="center" >Agregar nuevo rol</h1>
<div mat-dialog-content>
  <form [formGroup]="RolForm" fxLayout="row wrap" fxLayoutAlign="flex-start">
    <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="50" fxFlex.md="30" fxFlex.lg="120" fxFlex.gt-lg="22.5" class="px-1" ngClass.sm="mt-1" ngClass.xs="mt-1">
      <mat-form-field appearance="outline" class="w-100 mt-2">
          <mat-label>Nombre</mat-label>
          <input matInput placeholder="Nombre del rol" formControlName="name">
          <mat-error *ngIf="RolForm.controls['name'].invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
    </div>
    <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="50" fxFlex.md="30" fxFlex.lg="100" fxFlex.gt-lg="22.5" class="px-1" ngClass.sm="mt-1" ngClass.xs="mt-1">
      <mat-form-field appearance="outline">
        <mat-label>Estado</mat-label>
        <mat-select  formControlName="active" matNativeControl required>
          <mat-option value='1'>Activo</mat-option>
          <mat-option value='0'>Inactivo</mat-option>
        </mat-select>
        <mat-error *ngIf="RolForm.controls['active'].invalid">{{getErrorMessageStatus()}}</mat-error>
      </mat-form-field>
  </div>
</form>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
  <button mat-stroked-button color="warn" (click)="onNoClick()">Cancel</button>
  <button mat-raised-button color="primary" (click)="OnSubmit()" cdkFocusInitial>Guardar</button>
</div>